import React from 'react';
import { Route } from 'react-router-dom';

import IndexPage from 'pages/currency/index';
import ProfilePage from 'pages/currency/profile';

const collection = 'currency';
const menuItem = ['DATABASE', 'CURRENCY'];

const routes = [
  <Route
    path={`/${collection}`}
    element={<IndexPage menuItem={menuItem} title="貨幣管理" collection={collection} />}
  />,
  <Route
    path={`/${collection}/profile/:_id`}
    element={<ProfilePage menuItem={menuItem} title="貨幣" collection={collection} editMode="edit" />}
  />,
  <Route
    path={`/${collection}/copy/:_id`}
    element={<ProfilePage menuItem={menuItem} title="新增貨幣" collection={collection} editMode="copy" />}
  />,
  <Route
    path={`/${collection}/new`}
    element={<ProfilePage menuItem={menuItem} title="新增貨幣" collection={collection} editMode="new" />}
  />
];

export default routes;
